jQuery( document ).ready(function($) {

  if($('.temoignages').length > 0) {
    jQuery('.temoignages_owl.owl-carousel').owlCarousel({
      loop: true,
      nav: true,
      dots: false,
      responsive:{
        0:{
          items: 1,
          nav: false,
          dots: true,
          autoplay: true,
          autoplayTimeout: 6000,
        },
        900:{
          navText: ["<i class='nav-left-owl'>","<i class='nav-right-owl'>"],
          nav: true,
          items: 2
        }
      }
  })
  }
});

